<template>
  <div class="row justify-content-center">
    <div class="col-12">
      <!-- Substep 1 - Notice of process initiation. -->
      <div
        class="col-12 d-flex justify-content-center mt-5"
        v-if="onBoarding.substep == 1"
      >
        <div class="col-6 col-lg-4 text-center">
          <p>
            {{
              $t(
                "lang.onBoarding.step2_1_hint",
                this.$store.state.onboarding.lang
              )
            }}
          </p>
          <h5 class="mt-5">
            {{
              $t(
                "lang.onBoarding.step2_1_question1",
                this.$store.state.onboarding.lang
              )
            }}
          </h5>
          <h5 class="mt-5">
            {{
              $t(
                "lang.onBoarding.step2_1_question2",
                this.$store.state.onboarding.lang
              )
            }}
          </h5>
        </div>
      </div>

      <!-- Substep 2 - Options Apollo - target. -->
      <div class="col-12  mt-5" v-if="onBoarding.substep == 2">
        <div class="p-0 text-left">
          <div class="row">
            <div class=" col-md-5 col-lg-5 col-xl-5">
              <div class="float-end">
                <Step2Summary
                  :key="step2sum"
                  :poupView="true"
                  @change="refreshTarget($event)"
                  :selectDisable="false"
                  @save="savenow(false, false)"
                />
              </div>
            </div>
            <div class="col-md-7 col-lg-7 col-xl-7 mt-2">
              <TargetsModal
                v-if="!onBoarding.loading"
                :key="targetkey"
                :contactkey="targetkey + 1"
                :contacts="apolloResult"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TargetsModal from "@/components/Onboarding/TargetsModal.vue";
import { targetsService } from "@/_services";
import Step2Summary from "@/components/Onboarding/MultiSteps/Step2Summary.vue";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import KeyWordSearch from "@/components/AccountCreation/Steps/Campaign/search/KeyWordSearch.vue";
import { mapState, mapActions } from "vuex";
import Modal from "@/components/Common/Modal.vue";

export default {
  computed: {
    ...mapState({
      optionsList: state => state.optionsList,
      completeLoadingTarget: state => state.optionsList.completeLoadingTarget,
      onBoarding: state => state.onboarding,
      loadingOnBoarding: state => state.onboarding.loading,
      currentUser: state => state.authentication.user,
      isDisable: state => state.onboarding.isDisable
    })
  },
  data() {
    return {
      step2sum: 2322,
      targetkey: 232232,
      size: {
        greater: 0,
        less: 0
      },
      addSelect: false,
      apolloResult: {},
      apollo: {
        people: [],
        total_result: 0
      },
      select_list_sizes: [
        { id: 0, label: "1-10" },
        { id: 1, label: "11-20" },
        { id: 2, label: "21-50" },
        { id: 3, label: "51-100" },
        { id: 4, label: "101-200" },
        { id: 5, label: "201-500" },
        { id: 6, label: "501-1000" },
        { id: 7, label: "1001-2000" },
        { id: 8, label: "2001-5000" },
        { id: 9, label: "5001-10000" },
        { id: 10, label: "10001+" }
      ],
      selected_sizes: []
    };
  },

  components: {
    IndustrySearch,
    TargetsModal,
    Step2Summary,
    Modal,
    KeyWordSearch
  },
  mounted() {
    if (!this.completeLoadingTarget) {
      this.$store.dispatch("optionsList/getAllTargetParams");
    }
    this.addSelect = true;
  },

  methods: {
    ...mapActions("onboarding", {
      getApollo: "getApollo",
      setStep: "goToStep",
      setSubStep: "goToSubStep",
      updateSizeCompany: "updateSizeCompany",
      saveOrder: "save",
      updateCategoryJobs: "updateCategoryJobs"
    }),

    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },

    disabledEdit() {
      //1 > active or prepearing
      //2 > stop or inactive
      //3 > pending
      //4 > running
      //5 > archived

      if (this.currentUser.role_id == 1 && this.onBoarding.target_status_id !=4) {
        return false;
      }

      if (this.hasPermissions("adminClients") && this.onBoarding.target_status_id !=4) {
        return false;
      }

      return (
        this.target_status_id == 4 ||
        this.target_status_id == 2 ||
        this.target_status_id == 1
      );
    },

    goToSubStep(subStep, nextStep = true) {
      this.saveOrder();
      if (subStep > 6 && nextStep) {
        this.setStep(3);
        this.setSubStep(1);
      }
      this.setSubStep(subStep);
    },
    showModal(step) {
      this.$modal.show("step" + step);
    },
    closeModal(step) {
      this.$modal.hide("step" + step);
      this.request = false;
    },
    refreshTarget(result) {
      //console.log("result apollo", result);
      this.apolloResult = result;
    },

    onSelected(data) {
      if (data) {
        this.addSelect = true;
      }
    },
    onSelectedEmployes(data) {
      if (data.id || data.label == "1-10") {
        this.addSelect = true;
      }
    },

    changeKeywords(e) {
      this.updateCategoryJobs(e);
      this.getApollo();
    },

    // setEmployersSize(data) {
    //   this.size = this.select_list_sizes[data.id].label.split("-");

    //   this.updateSizeCompany(data.id);
    // },

    setEmployersSize(data) {
      if (this.addSelect) {
        if (data) {
          this.isDisable = true;
          this.selected_sizes = data;
          this.fillKeywordsSizes();
          this.loadApollo();
        }
      }
    },

    removeEmployersSize(data) {
      this.addSelect = true;
      this.isDisable = true;
      let index = this.selected_sizes.indexOf(data.id);
      this.selected_sizes.splice(index, 1);
      this.fillKeywordsSizes();
      this.loadApollo();
    },
    fillKeywordsSizes() {
      let greater = 0;
      let less = 0;
      this.selected_sizes.sort();

      this.selected_sizes.forEach((value, index) => {
        let keywords = this.select_list_sizes[value].label
          .replace("+", "")
          .split("-");
        if (!keywords[1]) {
          keywords[1] = "10000000";
        }
        if (Number(keywords[0]) < greater || greater === 0) {
          greater = Number(keywords[0]);
        }
        if (Number(keywords[1]) > less) {
          less = Number(keywords[1]);
        }
      });

      this.size.greater = greater;
      this.size.less = less;
    },

    loadApollo() {
      if (this.addSelect) {
        this.getApollo();
      }
    }
  }
};
</script>
